import { useState } from "react";
import { Task } from "@/types/task-management";
import TaskForm from "./TaskForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface CreateTaskDialogProps {
  trigger?: React.ReactNode;
  onTaskCreated: (task: Partial<Task>) => void;
  title?: string;
  isFloating?: boolean;
  initialValues?: Partial<Task>;
}

export default function CreateTaskDialog({ 
  trigger, 
  onTaskCreated, 
  title = "Nova Tarefa",
  isFloating = false,
  initialValues
}: CreateTaskDialogProps) {
  const [open, setOpen] = useState(false);
  
  const handleSubmit = (taskData: Partial<Task>) => {
    onTaskCreated(taskData);
    setOpen(false);
  };
  
  const handleCancel = () => {
    setOpen(false);
  };
  
  const defaultTrigger = (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {isFloating ? (
            <Button 
              className="h-14 w-14 rounded-full shadow-md fixed bottom-6 right-6 z-10" 
              size="icon"
            >
              <Plus className="h-6 w-6" />
            </Button>
          ) : (
            <Button className="gap-1">
              <Plus className="h-4 w-4" />
              <span>Nova tarefa</span>
            </Button>
          )}
        </TooltipTrigger>
        <TooltipContent>
          <p>Criar nova tarefa</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
  
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || defaultTrigger}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        
        <TaskForm 
          initialValues={initialValues}
          onSubmit={handleSubmit} 
          onCancel={handleCancel}
          submitButtonLabel="Criar tarefa"
        />
      </DialogContent>
    </Dialog>
  );
} 